import Client from './Client';

export default class CounselorClient {
  constructor() {
    this.client = Client;
  }

  /**
   * 获取学员报名列表
   */
  async getList(data) {
    const res = await this.client.post('/api/counselor/page', data);
    return res;
  }

  /**
   * 获取绑定辅导员的机构
   */
  async listAgencyNameByCounselor() {
    const res = await this.client.post('/api/counselor/listAgencyNameByCounselor');
    return res;
  }

  /**
   * 获取绑定辅导员的课程列表
   */
  async listNameByCounselor() {
    const res = await this.client.post('/api/course/listNameByCounselor');
    return res;
  }

  /**
   * 辅导员启用/禁用
   */
  async updateValid(data) {
    const res = await this.client.post('/api/counselor/updateValid', data);
    return res;
  }

  /**
   * 辅导员视频审核启用/禁用
   */
  async updateCheckVideo(data) {
    const res = await this.client.post('/api/counselor/updateCheckVideo', data);
    return res;
  }

  /**
   * 辅导员新增修改
   */
  async upsert(data) {
    const res = await this.client.post('/api/counselor/upsert', data);
    return res;
  }

  /**
   * 辅导员新增手机号校验
   */
  async checkMobilePhone(data) {
    const res = await this.client.post('/api/counselor/checkMobilePhone', data);
    return res;
  }

  /**
   * 辅导员详情
   */
  async getDetail(data) {
    const res = await this.client.post('/api/counselor/getDetail', data);
    return res;
  }
}